const UrlParser = require('./urlParser');
const parser = new UrlParser();
module.exports = parser;
